import { z } from 'zod';
import { FindingSchema, StrengthSchema } from './analysis-output.js';
/**
 * Comparação entre duas análises do mesmo user.
 *
 * Match heurístico: findings/strengths com mesma `(category, title)` são
 * considerados "o mesmo item" entre análises. IDs gerados pelo LLM mudam
 * entre runs e não servem pra match.
 */
export const AnalysisCompareSummarySchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string(),
    label: z.string().nullable(),
    modelId: z.string(),
    findingsCount: z.number().int(),
    criticalCount: z.number().int(),
    durationMs: z.number().int(),
    positioningSentence: z.string(),
    headline: z.string().nullable(),
    summary: z.string().nullable(),
});
export const FindingDiffSchema = z.object({
    added: z.array(FindingSchema),
    removed: z.array(FindingSchema),
    persisted: z.array(z.object({
        a: FindingSchema,
        b: FindingSchema,
        severityChanged: z.boolean(),
    })),
});
export const StrengthDiffSchema = z.object({
    added: z.array(StrengthSchema),
    removed: z.array(StrengthSchema),
    persisted: z.array(StrengthSchema),
});
export const AnalysisDiffSchema = z.object({
    a: AnalysisCompareSummarySchema,
    b: AnalysisCompareSummarySchema,
    findings: FindingDiffSchema,
    strengths: StrengthDiffSchema,
    counts: z.object({
        findingsDelta: z.number().int(),
        criticalDelta: z.number().int(),
        durationDelta: z.number().int(),
    }),
});
//# sourceMappingURL=analysis-diff.js.map